import { callAPI } from '../../../utils/call-api'

export const getAddressProvider = async ({ params }) => {
  const response = await callAPI(
    {
      url: `/addressprovider`,
      method: 'get',
      params: {
        ...params,
      },
    },
    null
  )
  return response.data
}

export const getMemberAddress = async ({ params, token }) => {
  const response = await callAPI(
    {
      url: `/address`,
      method: 'get',
      params: {
        ...params,
      },
    },
    token
  )
  return response.data
}

export const getMemberAddressById = async ({ id, token }) => {
  const response = await callAPI(
    {
      url: `/address/${id}`,
      method: 'get',
    },
    token
  )
  return response.data
}

export const postAddress = async ({ token, data }) => {
  return callAPI(
    {
      url: `/address`,
      method: 'post',
      data,
    },
    token
  )
}

export const patchAddress = async ({ token, addressId, data }) => {
  return callAPI(
    {
      url: `/address/edit/${addressId}`,
      method: 'patch',
      data,
    },
    token
  )
}

export const deleteAddress = async ({ token, addressId }) => {
  return callAPI(
    {
      url: `/address/delete/${addressId}`,
      method: 'delete',
    },
    token
  )
}
